<template>
  <div id="main">
    <div class="wrapper" v-if="$store.state.isLoggedIn">
      <template>
        <!-- <v-toolbar color="blue-grey" dark fixed app clipped-right>
          <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
          <v-toolbar-title>Toolbar</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>-->

        <app-header @onTrigger="drawer = !drawer"></app-header>
        <v-navigation-drawer
          fixed
          v-model="drawer"
          dark
          app
          :class="{ menu: true, default: isDefaultTheme, primary: !isDefaultTheme }"
        >
          <v-layout>
            <v-flex>
              <v-btn fab flat dark small @click="onGoHome">
                <v-icon>home</v-icon>
              </v-btn>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn fab flat dark small @click="drawer = false" class="hidden-sm-and-up">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <ul class="home-m menu-list"></ul>
          <!-- <div class="home-l row" style="margin-top: 5px;">
            <div class="col s6">
              <router-link
                :to="'/'+$i18n.locale()+'/allbots'"
                class="link link-white"
                style="font-size: 18px;"
              >
                <i class="fas fa-home"></i>
              </router-link>
            </div>
            <div class="col s6 right-align">
              <a
                href="javascript:void(0);"
                class="menu-close link link-white"
                style="font-size: 18px;"
                @click="showMenu = false"
              >
                <i class="fas fa-chevron-left"></i>
              </a>
            </div>
          </div>-->

          <div class="text-xs-center">
            <div class="avatar mb-4">
              <div class="avatar-img" style="position: relative">
                <div style="position: absolute; right: -5px; top: -5px">
                  <template
                    v-if="
                      !selectedBot.pagerole ||
                      (selectedBot.pagerole && selectedBot.pagerole == 'admin')
                    "
                  ></template>
                </div>
                <v-avatar size="100px">
                  <img
                    class="responsive-img circle"
                    style="min-width: 100%"
                    alt
                    @error="onError"
                    :src="
                      'https://graph.facebook.com/' +
                      selectedBot.pageid +
                      '/picture?width=100&height=100&SameSite=None'
                    "
                    :class="{
                      'bot-active': selectedBot.status,
                      'bot-inactive': !selectedBot.status,
                    }"
                  />
                </v-avatar>
              </div>
            </div>

            <div style="margin-bottom: 15px">
              <div class="status active" v-if="selectedBot.status">
                <i class="fas fa-play"></i>
                <span style="margin-left: 5px">{{ $t('active') }}</span>
              </div>
              <div class="status inactive" v-else>
                <i class="fas fa-pause"></i>
                <span style="margin-left: 5px">{{ $t('inactive') }}</span>
              </div>
            </div>

            <v-menu
              offset-y
              open-on-hover
              offset-overflow
              max-height="200"
              v-if="!$store.state.userid.includes('zwiz')"
            >
              <template v-slot:activator="{ on }">
                <v-btn round outline v-on="on" class="select-page-list" dark small>
                  <div
                    class="text-truncate"
                    style="
                      display: inline-block;
                      word-break: break-all;
                      max-width: 150px;
                      vertical-align: middle;
                    "
                  >
                    {{ selectedBot.pagename }}
                  </div>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile
                  v-for="(item, index) in optionBotlist"
                  :key="index"
                  @click="selectBot(item)"
                >
                  <v-list-tile-title class="primary-color">{{ item.name }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>

          <div class="mt-4">
            <div>
              <ul class="menu-list">
                <template
                  v-if="
                    ((!selectedBot.pagerole ||
                      (selectedBot.pagerole && selectedBot.pagerole == 'admin')) &&
                      (selectedBot.theme != 'kasikorncareer' ||
                        $store.state.userid != 'kbankadmin')) ||
                    selectedBot.theme == 'universalutilities'
                  "
                >
                  <router-link
                    :to="'/' + $i18n.locale() + '/welcome'"
                    :data-intro="
                      $t(
                        'Make a great First Impression moment for your customers by setting Welcome Message here.'
                      )
                    "
                    data-position="right"
                    v-if="selectedBot.theme != 'universalutilities' && isShowMenu('welcome')"
                  >
                    <li tabindex="0" class="icon-greeting">
                      <span>{{ $t('Welcome Message') }}</span>
                    </li>
                  </router-link>
                </template>
                <template
                  v-if="
                    !selectedBot.pagerole ||
                    (selectedBot.pagerole && selectedBot.pagerole == 'admin') ||
                    selectedBot.theme == 'universalutilities'
                  "
                >
                  <router-link
                    v-if="isShowMenu('conversation')"
                    :to="'/' + $i18n.locale() + '/conversation'"
                    :data-intro="
                      $t(
                        'This Conversation page is like a heart of CHATBOT, the page will collect all pattern on how Bot replies all messages.'
                      )
                    "
                  >
                    <li tabindex="0" class="icon-speech">
                      <span>{{ $t('Conversation') }}</span>
                    </li>
                  </router-link>
                </template>
                <template
                  v-if="
                    ((!selectedBot.pagerole ||
                      (selectedBot.pagerole && selectedBot.pagerole == 'admin')) &&
                      (selectedBot.theme != 'kasikorncareer' ||
                        $store.state.userid != 'kbankadmin')) ||
                    selectedBot.theme == 'universalutilities'
                  "
                >
                  <router-link
                    :to="'/' + $i18n.locale() + '/comment'"
                    :data-intro="
                      $t(
                        'To privately chat with the one who comments on your post, this page is how you can set which comment that you want to pull directly to your inbox and how to reply on those comments'
                      )
                    "
                    v-if="
                      !['universalutilities', 'scgworkplace'].includes(selectedBot.theme) &&
                      isShowMenu('comment')
                    "
                  >
                    <li tabindex="0" class="icon-mailbox">
                      <span>{{ $t('Comment to Inbox') }}</span>
                    </li>
                  </router-link>
                  <router-link
                    v-if="!['scgworkplace'].includes(selectedBot.theme) && isShowMenu('broadcast')"
                    :to="'/' + $i18n.locale() + '/broadcast'"
                    :data-intro="
                      $t(
                        'If you want to sent any messages to your customers via Facebook s inbox, you can easily set them here'
                      )
                    "
                  >
                    <li tabindex="0" class="icon-megaphone">
                      <span>{{ $t('Broadcast') }}</span>
                    </li>
                  </router-link>
                  <router-link
                    v-if="['sahapan'].includes(selectedBot.theme)"
                    :to="'/' + $i18n.locale() + '/rewardmanager'"
                  >
                    <li tabindex="0" class="icon-reward">
                      <span>{{ $t('Reward Manager') }}</span>
                    </li>
                  </router-link>
                  <template
                    v-if="$store.state.livepage.includes(selectedBot.pageid) && isShowMenu('live')"
                  >
                    <router-link :to="'/' + $i18n.locale() + '/live'">
                      <li tabindex="0" class="icon-live">
                        <span>{{ $t('Live') }}</span>
                        <v-chip
                          small
                          style="width: auto"
                          class="ml-2 new-badge"
                          color="red"
                          disabled
                          >{{ $t('New') }}</v-chip
                        >
                      </li>
                    </router-link>
                  </template>
                  <template v-if="['ticket'].includes(selectedBot.theme)">
                    <router-link :to="'/' + $i18n.locale() + '/ticket'">
                      <li tabindex="0" class="icon-ticket">
                        <span>{{ $t('Ticketing') }}</span>
                      </li>
                    </router-link>
                  </template>

                  <template
                    v-if="
                      [
                        'ecommercebasic',
                        'adminperform',
                        'sahapan',
                        'nvbb',
                        'ticket',
                        'bec',
                      ].includes(selectedBot.theme) && isShowMenu('template')
                    "
                  >
                    <router-link
                      :to="'/' + $i18n.locale() + '/template'"
                      :data-intro="
                        $t(
                          'If you sell any product, Shop Service might be another choice to support you. You can edit and update all the selling process here inlcuding add product, payment system, tracking system, etc.'
                        )
                      "
                    >
                      <li tabindex="0" class="icon-shop">
                        <span>{{ $t('Shop Service') }}</span>
                      </li>
                    </router-link>
                  </template>
                  <template
                    v-else-if="
                      !['ceemeagain', 'scgworkplace', 'universalutilities'].includes(
                        selectedBot.theme
                      ) && isShowMenu('template')
                    "
                  >
                    <router-link :to="'/' + $i18n.locale() + '/template'">
                      <li tabindex="0" class="icon-plugin">
                        <span>Plug-In</span>
                      </li>
                    </router-link>
                  </template>
                  <router-link
                    :to="'/' + $i18n.locale() + '/livechat'"
                    v-if="
                      (isShowMenu('livechat') &&
                        selectedBot.pagetype == 'enterprise' &&
                        $store.state.livechatPageList.includes(selectedBot.theme)) ||
                      $store.state.livechatPageIdList.includes(selectedBot.pageid) ||
                      (selectedBot.theme == 'ecommercebasic' &&
                        selectedBot.pageid == '270028443161479')
                    "
                  >
                    <li tabindex="0" class="icon-speech">
                      <span>{{ $t('Live Chat') }}</span>
                    </li>
                  </router-link>
                </template>
                <router-link
                  v-if="isShowMenu('dashboard')"
                  :to="'/' + $i18n.locale() + '/dashboard'"
                  :data-intro="
                    $t(
                      'It is the place where you can see both analytics data; conversation and customer'
                    )
                  "
                >
                  <li tabindex="0" class="icon-analytics">
                    <span>{{ $t('analytics') }}</span>
                  </li>
                </router-link>
                <template
                  v-if="
                    !selectedBot.pagerole ||
                    (selectedBot.pagerole && selectedBot.pagerole == 'admin')
                  "
                >
                  <router-link
                    v-if="isShowMenu('training')"
                    :to="'/' + $i18n.locale() + '/training'"
                    :data-intro="
                      $t('This page is for training Bot to be smarter, and reduce default words !')
                    "
                  >
                    <li tabindex="0" class="icon-gym">
                      <span>{{ $t('Training') }}</span>
                    </li>
                  </router-link>
                </template>
                <v-divider />
                <template
                  v-if="
                    (!selectedBot.pagerole ||
                      (selectedBot.pagerole && selectedBot.pagerole == 'admin')) &&
                    (selectedBot.theme != 'kasikorncareer' || $store.state.userid != 'kbankadmin')
                  "
                >
                  <router-link
                    v-if="isShowMenu('billing')"
                    :to="'/' + $i18n.locale() + '/billing'"
                    :data-intro="
                      $t(
                        'On Setting Page, you can  turn On / Off Bot, remove Bot, and check your Subscription Day Remaining. But please dont remove me :('
                      )
                    "
                  >
                    <li tabindex="0" class="icon-setting">
                      <span>{{ $t('Setting') }}</span>
                    </li>
                  </router-link>
                </template>
                <!-- <template
                  v-if="
                    !selectedBot.pagerole ||
                      (selectedBot.pagerole && selectedBot.pagerole == 'admin')
                  "
                >
                  <router-link
                    v-if="['universalutilities','scgworkplace', 'scgallrent'].includes(selectedBot.theme) == false"
                    :to="'/' + $i18n.locale() + '/redeemcode'"
                    :data-intro="
                      $t(
                        'On Setting Page, you can  turn On / Off Bot, remove Bot, and check your Subscription Day Remaining. But please dont remove me :('
                      )
                    "
                  >
                    <li tabindex="0" class="icon-ticket">
                      <span>{{ $t('Redeem Code') }}</span>
                    </li>
                  </router-link>
                </template>-->
                <!-- <a
                  href="https://blog.zwiz.ai/getstarted-zwizai/"
                  target="_blank"
                  :data-intro="$t('Have a question? got an answer at tutorial.')"
                  v-if="
                    (selectedBot.theme != 'kasikorncareer' ||
                      $store.state.userid != 'kbankadmin') &&
                      selectedBot.theme != 'universalutilities'
                  "
                >
                  <li tabindex="0" class="icon-help">
                    <span>{{ $t('help') }}</span>
                  </li>
                </a>-->
                <li
                  tabindex="0"
                  class="icon-sign-out"
                  @click="logout"
                  :data-intro="
                    $t('Click here, if your setting is finished or if you want to sigh out.')
                  "
                >
                  <span>{{ $t('Sign Out') }}</span>
                </li>
                <v-divider />
                <template
                  v-if="
                    ((isShowMenu('upgrade') && !selectedBot.pagerole) ||
                      (selectedBot.pagerole && selectedBot.pagerole == 'admin')) &&
                    selectedBot.pagetype != 'enterprise' &&
                    (selectedBot.theme != 'kasikorncareer' || $store.state.userid != 'kbankadmin')
                  "
                >
                  <router-link
                    :to="'/' + $i18n.locale() + '/upgrade'"
                    :data-intro="
                      $t('To see the differences between Basic and Premium Package, click here')
                    "
                  >
                    <li tabindex="0" class="icon-premium">
                      <span>
                        {{ $t('Upgrade to Premium Plan') }}
                        <v-chip
                          small
                          style="width: auto"
                          class="ml-2 new-badge"
                          color="red"
                          disabled
                          >{{ $t('New') }}</v-chip
                        >
                      </span>
                    </li>
                  </router-link>
                </template>
              </ul>
            </div>
          </div>
        </v-navigation-drawer>
        <v-content>
          <div style="position: relative" class="thishiw">
            <div class="alert-header alert-warning" v-if="!selectedBot.status" role="alert">
              <v-container fluid>
                <v-layout wrap>
                  <v-flex xs2 sm1 class="text-xs-center">
                    <vue-simple-svg
                      :filepath="'/static/img/assets/_global/warning.svg'"
                      width="30px"
                      height="auto"
                      class="icon"
                    />
                  </v-flex>
                  <v-flex xs8 sm10>
                    <div class="strong">{{ $t('Warning!') }}</div>
                    {{ $t('If you want to test, please activate your bot') }}
                    <a href="javascript:void(0);" @click="toggleBotStatus">{{
                      $t('Click for starting your Bot')
                    }}</a>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>

            <div
              class="alert-header alert-warning"
              role="alert"
              v-if="expriedTime > 0 && expriedDate <= 7 && showAlertExpiredPackage"
            >
              <v-container fluid>
                <v-layout wrap>
                  <v-flex xs2 sm1 class="text-xs-center">
                    <vue-simple-svg
                      :filepath="'/static/img/assets/_global/warning.svg'"
                      width="30px"
                      height="auto"
                      class="icon"
                    />
                  </v-flex>
                  <v-flex xs8 sm10>
                    <div class="strong" style="padding-right: 15px">{{ $t('Warning!') }}</div>
                    {{ $t('Your package will be expired in') }}
                    <template v-if="expriedTime > 0">
                      <countdown :time="expriedTime * 1000">
                        <template slot-scope="props">
                          <template v-if="props.days">
                            {{ props.days }}
                            <span class="small">{{ $t('Days') }}</span>
                          </template>
                          <template v-else-if="props.hours > 0">
                            {{ props.hours }}
                            <span class="small">{{ $t('Hours') }}</span>
                          </template>
                          <template v-else-if="props.minutes > 0">
                            {{ props.minutes }}
                            <span class="small">{{ $t('minutes') }}</span>
                          </template>
                          <template v-else>
                            {{ props.seconds }}
                            <span class="small">{{ $t('seconds') }}</span>
                          </template>
                        </template>
                      </countdown>
                      <!-- {{expriedTime}}  -->
                    </template>
                    <router-link
                      :to="'/' + $i18n.locale() + '/upgrade'"
                      v-if="selectedBot.pagetype != 'enterprise'"
                      >{{ $t('click here to extent your package') }}</router-link
                    >
                  </v-flex>
                  <v-flex xs2 sm1 class="text-xs-right">
                    <v-btn
                      flat
                      fab
                      small
                      dark
                      @click="$store.dispatch('clearAlert', 'expriedPackage')"
                    >
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>

            <div
              class="alert-header alert-warning grey"
              role="alert"
              v-if="isPremiumExpired && showAlertExpiredPremium"
            >
              <v-container fluid>
                <v-layout wrap>
                  <v-flex xs2 sm1 class="text-xs-center">
                    <vue-simple-svg
                      :filepath="'/static/img/assets/_global/warning.svg'"
                      width="30px"
                      height="auto"
                      class="icon"
                    />
                  </v-flex>
                  <v-flex xs8 sm10>
                    <div class="strong" style="padding-right: 15px">{{ $t('Warning!') }}</div>
                    {{
                      $t('Your premium package has expired, click here to continue this package')
                    }}
                    <template v-if="expriedTime > 0">
                      <countdown :time="expriedTime * 1000">
                        <template slot-scope="props">
                          <template v-if="props.days">
                            {{ props.days }}
                            <span class="small">{{ $t('Days') }}</span>
                          </template>
                          <template v-else-if="props.hours > 0">
                            {{ props.hours }}
                            <span class="small">{{ $t('Hours') }}</span>
                          </template>
                          <template v-else-if="props.minutes > 0">
                            {{ props.minutes }}
                            <span class="small">{{ $t('minutes') }}</span>
                          </template>
                          <template v-else>
                            {{ props.seconds }}
                            <span class="small">{{ $t('seconds') }}</span>
                          </template>
                        </template>
                      </countdown>
                      <!-- {{expriedTime}}  -->
                    </template>
                    <a
                      @click="$router.push('Upgrade')"
                      target="_blank"
                      v-if="selectedBot.pagetype != 'enterprise'"
                      >{{ $t('click here to extent your package') }}</a
                    >
                  </v-flex>
                  <v-flex xs2 sm1 class="text-xs-right">
                    <v-btn
                      flat
                      fab
                      small
                      dark
                      @click="$store.dispatch('clearAlert', 'expriedPremium')"
                    >
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>

            <!-- <div class="alert-header alert-new">
                  <div class="container">
                    <div class="row" style="margin-bottom :0">
                      <div class="col s12" style="display: flex">
                        <vue-simple-svg
                          :filepath="'/static/img/assets/_global/new.svg'"
                          width="30px"
                          height="auto"
                          class="icon"
                        />
                        <div style="padding-left: 10px">
                          <div class="strong">{{$t('New version!')}}</div>
                          {{$t('Zwiz.ai update new version')}}
                          <a
                            href="https://blog.zwiz.ai/getstarted-zwizai/"
                            target="_blank"
                          >{{$t('Read tutorial')}}</a>
                        </div>
                      </div>
                    </div>
                  </div>
            </div>-->
            <div
              class="alert-header alert-line"
              v-if="!selectedBot.packages.includes('line') && showAlertLine && false"
            >
              <v-container fluid>
                <v-layout wrap>
                  <v-flex xs2 sm1 class="text-xs-center">
                    <vue-simple-svg
                      :filepath="'/static/img/assets/_global/line.svg'"
                      width="30px"
                      height="auto"
                      class="icon"
                    />
                  </v-flex>
                  <v-flex xs8 sm10>
                    <div class="strong">{{ $t('Line Chatbot is available!') }}</div>
                    {{ $t('Connect with line now') }}
                    <a href="https://blog.zwiz.ai/tutorial-7-เชื่อม-line/" target="_blank">{{
                      $t('Read tutorial')
                    }}</a>
                    {{ $t('and') }}
                    <router-link :to="'/' + currentLang + '/billing?go=line'">{{
                      $t('Go to setup')
                    }}</router-link>
                  </v-flex>
                  <v-flex xs2 sm1 class="text-xs-right">
                    <v-btn flat fab small dark @click="$store.dispatch('clearAlert', 'line')">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
            <div class="alert-header alert-warning red" v-if="selectedBot.statustoken === false">
              <v-container fluid>
                <v-layout wrap>
                  <v-flex xs2 sm1 class="text-xs-center">
                    <vue-simple-svg
                      :filepath="'/static/img/assets/_global/warning.svg'"
                      width="30px"
                      height="auto"
                      class="icon"
                    />
                  </v-flex>
                  <v-flex xs8 sm10>
                    <div class="strong">{{ $t('Hey! Your chatbot has connection error.') }}</div>
                    {{ $t('Admin page please log into the zwiz system') + ' ' + $t('again.') }}
                  </v-flex>
                  <v-flex xs2 sm1 class="text-xs-right">
                    <v-btn flat fab small dark @click="$store.dispatch('clearAlert', 'line')">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
            <div
              v-if="showAds && selectedBot.pagetype != 'enterprise' && $route.name != 'livechat'"
            >
              <div @click="clickAds" style="position: relative; cursor: pointer">
                <v-img src="/static/img/banner.jpg"></v-img>
                <v-btn
                  @click.stop="closeAds"
                  depressed
                  icon
                  style="background-color: orange; position: absolute; right: 2px; top: 2px"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
          <slot></slot>
        </v-content>

        <!-- <div id="view-content" style="display: flex;" :class="{'show-menu': showMenu}">
          <div class="menu">
            <div v-bar style="height: 100vh">
              <div>
                <div class="smartphone-menu-trigger"></div>
                
              </div>
            </div>
          </div>
          <div class="main" v-bar>
            <div>
              <div class="menu-overlay" @click="showMenu = false"></div>
              <app-header @openMenu="showMenu = true" />
              
              <slot></slot>

              <div style="min-height: 80px;"></div>
            </div>
          </div>
        </div>-->
        <app-footer />
      </template>
    </div>

    <!-- <modal-dialog
      v-if="showUpsell1 && $store.getters.getPackage != 'premium'"
      @close="$store.dispatch('clearAlert','upsell1')"
    >
      <div slot="body">
        <a href="https://forms.gle/aSXqHuQ4XGNp8Xj1A" target="_blank" rel="noopener noreferrer">
          <v-img src="/static/img/assets/_global/ads_for_web_large.png"></v-img>
        </a>
      </div>
      <div slot="footer">
        <div class="text-xs-center mt-3">
          <v-btn
            outline
            color="primary"
            href="https://forms.gle/aSXqHuQ4XGNp8Xj1A"
            target="_blank"
          >สมัครเลย</v-btn>
        </div>
      </div>
    </modal-dialog>-->

    <modal-welcome></modal-welcome>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import header from '@/components/elements/header'
import footer from '@/components/elements/footer'
import dropdown from 'vue-dropdowns'
import moment from 'moment'
import ModalDialog from '@/components/elements/ModalDialog'
import ModalWelcome from '@/components/elements/ModalWelcome'

import ViewPackage from '@/components/view/setting/ViewPackage'
import Vue from 'Vue'

import api from '@/api'

import 'intro.js/minified/introjs.min.css'

export default {
  // name: "dashboard",
  components: {
    'app-header': header,
    'app-footer': footer,
    dropdown,
    ViewPackage,
    ModalDialog,
    ModalWelcome,
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      isSelectedBot: 'isSelectedBot',
      isFacebook: 'isFacebook',
      currentLang: 'currentLang',
      showModalWelcome: 'showModalWelcome',
    }),

    isDefaultTheme() {
      return this.$vuetify.theme.primary == '#FF706B'
    },
    isPremiumExpired() {
      let expire = this.$store.state.selectedBot.expireat
      let today = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSS')
      let register = this.$store.state.selectedBot.registerat
      return expire > register && expire < today
    },
    showUpsell1: function () {
      if (this.$store.getters.showAlert('upsell1') >= 0) {
        var alert = this.$store.getters.showAlert('upsell1')
        return alert.show
      } else {
        return true
      }
    },
    showAlertLine: function () {
      if (this.$store.getters.showAlert('line') >= 0) {
        var alert = this.$store.getters.showAlert('line')
        return alert.show
      } else {
        return true
      }
    },
    showAlertExpiredPackage: function () {
      if (this.$store.getters.showAlert('expriedPackage') >= 0) {
        var alert = this.$store.getters.showAlert('expriedPackage')
        return alert.show
      } else {
        return true
      }
    },
    showAlertExpiredPremium: function () {
      if (this.$store.getters.showAlert('expriedPremium') >= 0) {
        var alert = this.$store.getters.showAlert('expriedPremium')
        return alert.show
      } else {
        return true
      }
    },
    optionBotlist: function () {
      let options = []
      let vm = this
      $.each(vm.botlist, function (index, val) {
        if (val.pageid != vm.selectedBot.pageid) {
          options.push({ name: val.pagename, value: val.pageid })
        }
      })

      return options
    },
    filterBotlist: function () {},
  },
  data: function () {
    return {
      drawer: null,
      showAds: true,
      autostart: false,
      introConfig: {
        nextLabel: this.$t('Next'),
        prevLabel: this.$t('Back'),
        skipLabel: this.$t('skip'),
        doneLabel: this.$t('Finish'),
      },
      myOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish',
        },
      },
      showMenu: false,
      x: 0,
      y: 0,
      currentBot: null,
      pagelist: [],
      selectedOption: {},
      expriedTime: null,
      expriedDate: null,
    }
  },
  mounted: function () {
    var vm = this
    vm.$validator.localize(vm.currentLang)

    var now = moment()
    var expriedDate = moment(this.$store.state.selectedBot.expireat)
    this.expriedDate = parseInt(expriedDate.diff(now, 'days'))
    this.expriedTime = parseInt(expriedDate.diff(now, 'seconds'))

    vm.selectedOption = {
      name: vm.selectedBot.pagename,
      value: vm.selectedBot.pageid,
    }
    vm.getSetting(function (contents) {
      vm.$store.dispatch('updateSetting', contents)
    })

    vm.getWelcomeMessage(function (welcomeMessage) {
      vm.$store.dispatch('updateWelcomeMessage', welcomeMessage)
    })

    // this.$tours['myTour'].start()

    if (vm.showModalWelcome) {
      // vm.openTutorial()
    }
  },
  created: function () {
    var vm = this
    if (
      localStorage.getItem('hideads') &&
      localStorage.getItem('hideads').includes(this.selectedBot.pageid)
    ) {
      this.showAds = false
    }
  },
  methods: {
    closeAds() {
      var closeads = ''
      if (
        localStorage.getItem('hideads') &&
        !localStorage.getItem('hideads').includes(this.selectedBot.pageid)
      ) {
        closeads = localStorage.getItem('hideads') + ',' + this.selectedBot.pageid
      } else {
        closeads = this.selectedBot.pageid
      }
      localStorage.setItem('hideads', closeads)
      this.showAds = false
    },
    isShowMenu(menu) {
      // conversation
      // comment
      // broadcast
      // template
      // livechat
      // dashboard
      // training
      // billing
      if (this.selectedBot.theme == 'ticket') {
        if (this.$store.state.privilege && this.$store.state.privilege.agent_management) {
          return true
        } else return ['livechat'].includes(menu)
      } else if (this.selectedBot.theme == 'pregnant') {
        return !['comment','template'].includes(menu)
      }
       else if (this.$store.state.menubypageid[this.selectedBot.pageid]) {
        return this.$store.state.menubypageid[this.selectedBot.pageid].includes(menu)
      } else return true
    },
    onGoHome() {
      location.href = '/' + this.$i18n.locale() + '/allbots'
    },
    openTutorial: function () {
      var vm = this
      vm.$nextTick(function () {
        vm.showMenu = true
        setTimeout(() => {
          const introJS = require('intro.js')
          introJS
            .introJs()
            .setOption('nextLabel', vm.$t('Next'))
            .setOption('prevLabel', vm.$t('Back'))
            .setOption('skipLabel', vm.$t('skip'))
            .setOption('doneLabel', vm.$t('Finish'))
            .setOption('showBullets', false)
            .start()
        }, 1000)
      })
    },
    clickAds() {
      var prefix = window.location.hostname == 'cms.zwiz.ai' ? 'z_' : ''
      this.$ga.event('event', prefix + 'banner_5999', this.selectedBot.pagename)
      this.$router.push('upgrade')
    },
    logout: function () {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to Logout?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            var isFacebook = vm.isFacebook
            vm.$store.dispatch('logout', null).then()
            if (isFacebook) {
              vm.$router.push('/' + vm.currentLang + '/login')
            } else {
              vm.$router.push('/' + vm.currentLang + '/nigol')
            }
          }
        })
    },
    selectBot: function (page) {
      var vm = this
      vm.$store.dispatch('loading')
      $.each(vm.botlist, function (index, bot) {
        if (page.value === bot.pageid) {
          vm.$store.dispatch('selectBot', bot)
        }
      })
      location.reload()
    },
    onError: function (event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    show(e) {
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    getSetting: function (callback) {
      let vm = this
      var data = {
        pageid: vm.$store.state.selectedBot.pageid,
      }

      api.getSetting(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }

        var contents = {}
        $.each(response.data, function (index, val) {
          contents[val.contenttype] = val
        })
        callback(contents)
      })
    },
    getWelcomeMessage: function (callback) {
      let vm = this
      // vm.$store.dispatch('loading')
      let data = {
        pageid: vm.selectedBot.pageid,
      }

      var message = null
      var generics = [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true,
        },
      ]
      var messages = null
      var type = 'json'
      api.getWelcomeMessage(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          type = response.data.type
          if (type === 'message') {
            messages = [
              [
                {
                  text: response.data.message_text,
                  type: 'text',
                },
              ],
            ]
          } else if (type === 'generic') {
            messages = [[]]
            if (
              response.data.message &&
              typeof response.data.message === 'object' &&
              response.data.message.length > 0
            ) {
              $.each(response.data.message, function (index, val) {
                generics[index] = val
              })

              messages[0][0] = {
                type: 'generic',
                data: generics,
                ratio: response.data.ratio == 'horizontal' ? 'horizontal' : 'square',
              }
            }
          } else {
            if (vm.isJsonParseable(response.data.message)) {
              messages = JSON.parse(response.data.message)
            }
          }
          type = 'json'
        }
        callback({
          type: type,
          message: message,
          generics: generics,
          messages: messages,
        })
      })
    },
    toggleBotStatus: function () {
      let vm = this
      let bot = Object.assign({}, vm.selectedBot)
      bot.status = !bot.status

      let in_status_label = bot.status ? 'stop' : 'start'
      vm.$store.dispatch('loading')
      api.toggleBotStatus(bot, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }

        let newbotlist = vm.botlist
        $.each(newbotlist, function (index, oldbot) {
          if (bot.pageid == oldbot.pageid) {
            newbotlist[index].status = bot.status
            return false
          }
        })
        // console.log(bot)
        vm.botStatus = bot.status
        vm.$store.dispatch('selectBot', bot)
        vm.$store.dispatch('updateBotlist', newbotlist)
        vm.$store.dispatch('loading')
      })
    },
  },
}
</script>

<style lang="scss">
.menu.default {
  background-color: #ff846d !important;
}
.menu {
  .avatar {
    .bot-active {
      border: 3px solid #a0e83d;
    }

    .bot-inactive {
      border: 3px solid red;
    }
  }

  ul.menu-list {
    list-style: none;
    padding: 0.5em 0;
    margin: 0;

    .router-link-active {
      li {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }

    a {
      text-decoration: none;
    }
    li {
      font-size: 0.95em;
      font-weight: 300;
      background-repeat: no-repeat;
      background-position: left 15px center;
      background-size: auto 20px;
      transition: all 0.15s linear;
      padding: 1em 1em 1em 3em;
      cursor: pointer;

      &.icon-home {
        background-image: url('/static/img/assets/sidebar/home.svg');
      }

      &.icon-greeting {
        background-image: url('/static/img/assets/sidebar/greeting.svg');
      }

      &.icon-speech {
        background-image: url('/static/img/assets/sidebar/speech.svg');
      }

      &.icon-mailbox {
        background-image: url('/static/img/assets/sidebar/mailbox.svg');
      }

      &.icon-analytics {
        background-image: url('/static/img/assets/sidebar/analytics.svg');
      }

      &.icon-billing {
        background-image: url('/static/img/assets/sidebar/billing.svg');
      }

      &.icon-setting {
        background-image: url('/static/img/assets/sidebar/setting.svg');
      }
      &.icon-ticket {
        background-image: url('/static/img/assets/sidebar/ticket.svg');
      }

      &.icon-gym {
        background-image: url('/static/img/assets/sidebar/gym.svg');
      }

      &.icon-help {
        background-image: url('/static/img/assets/sidebar/help.svg');
      }

      &.icon-megaphone {
        background-image: url('/static/img/assets/sidebar/megaphone.svg');
      }
      &.icon-reward {
        background-image: url('/static/img/assets/sidebar/reward.svg');
      }

      &.icon-premium {
        background-image: url('/static/img/assets/sidebar/premium.svg');
      }

      &.icon-shop {
        background-image: url('/static/img/assets/sidebar/shop.svg');
      }

      &.icon-sign-out {
        background-image: url('/static/img/assets/sidebar/sign-out.svg');
      }

      &.icon-plugin {
        background-image: url('/static/img/assets/sidebar/plugin.svg');
      }
      &.icon-live {
        background-image: url('/static/img/assets/sidebar/live.svg');
      }
      &.icon-ticket {
        background-image: url('/static/img/assets/sidebar/technical-support.svg');
      }

      span {
        width: 100%;
        color: white;
        margin-left: 10px;
      }

      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }

    .devide {
      border-bottom: 1px solid #ff8c88;
    }
  }
}
h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--primary-color);
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Main.vue